import { NetworkError } from "./networkError";

export function getErrorText(
  error: unknown,
  statusMap: Record<string, string>,
): string {
  if (typeof error === "string" && error in statusMap) {
    return statusMap[error];
  } else if (error instanceof NetworkError) {
    if (error.message in statusMap) {
      return statusMap[error.message];
    }

    if (error.status in statusMap) {
      return statusMap[error.status];
    }
  } else if (error instanceof Error && error.message in statusMap) {
    return statusMap[error.message];
  }

  return "Ukjent feil";
}
